import { type FC } from "react";

import { faTrash } from "@fortawesome/pro-duotone-svg-icons/faTrash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { type Conversation } from "@app_schema";

import { useVisible } from "@application/hooks/use_visible";

import { Button } from "@styled/button";

import { ConversationDestroyDialog } from "./conversation_destroy_dialog";

export const ConversationDestroyButton: FC<{
  conversation: Pick<Conversation, "id"> & {
    agent: Pick<Conversation["agent"], "id" | "name">;
    policy: Pick<Conversation["policy"], "modify">;
  };
  onDestroy?(): void;
}> = ({ conversation, onDestroy }) => {
  const [visible, onToggle] = useVisible();

  if (!conversation.policy.modify) return;

  return (
    <>
      <Button color="rose" onClick={onToggle}>
        <FontAwesomeIcon icon={faTrash} /> Delete
      </Button>

      {visible && (
        <ConversationDestroyDialog
          conversation={conversation}
          onDestroy={onDestroy}
          onClose={onToggle}
        />
      )}
    </>
  );
};
